import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Table, Input, Button, Space, Checkbox } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import medicalInsuranceService from "../../../../api/MedicalInsurance/MedicalInsuranceService";
export default class PreviewAllMedicalInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = { medicalInsuranceList: [] };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getMedicalInsuranceList();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  getMedicalInsuranceList = () => {
    let medicalInsuranceList = this.state.medicalInsuranceList;
    medicalInsuranceService
      .getAllInsurances()
      .then((res) => {
        medicalInsuranceList = res.data;
        this.setState({ medicalInsuranceList });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  onSelectPreview = (id, checked) => {
    medicalInsuranceService.editInsurance(id, { isPreview: checked });
    toast.success(`Medical Insurance Updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getMedicalInsuranceList();
  };

  onButtonClick = (id) => {
    medicalInsuranceService.deleteInsurance(id);
    toast.success(`Medical Insurance Deleted Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getMedicalInsuranceList();
  };

  render() {
    let data =
      this.state.medicalInsuranceList != null
        ? this.state.medicalInsuranceList
            .sort((a, b) => a.createdAt > b.createdAt)
            .map((insurance, i) => {
              return {
                index: i + 1,
                class: insurance.class,
                description: insurance.description,
                ar_description: insurance.ar_description,
                isPreview: (
                  <Checkbox
                    defaultChecked={insurance.isPreview && insurance.isPreview}
                    onClick={(e) =>
                      this.onSelectPreview(insurance.id, e.target.checked)
                    }
                  />
                ),
                action: (
                  <Button
                    className="btn btn-danger text-white"
                    onClick={() => this.onButtonClick(insurance.id)}
                  >
                    Delete
                  </Button>
                ),
              };
            })
        : null;

    const columns = [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "Class",
        dataIndex: "class",
        key: "class",
        ...this.getColumnSearchProps("class"),
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        ...this.getColumnSearchProps("description"),
      },
      {
        title: "Arabic Description",
        dataIndex: "ar_description",
        key: "ar_description",
        ...this.getColumnSearchProps("ar_description"),
      },
      {
        title: "Preview?",
        dataIndex: "isPreview",
        key: "isPreview",
        ...this.getColumnSearchProps("isPreview"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ];
    return (
      <>
        <h5 className="m-0">Medical Insurances</h5>
        <Row form>
          <Col md="12" className="form-group  mt-4">
            <Table
              columns={columns}
              dataSource={data !== null ? data : null}
              className="p-0 m-0"
              pagination={{ pageSize: 5, position: ["bottomCenter"] }}
              style={{ textAlign: "center" }}
            />
          </Col>
        </Row>
      </>
    );
  }
}
